import axiosClient from './axiosClient';

const settingAccountApi = {
  get: (target) => {
    const url = `settings/${target}`;
    return axiosClient.get(url);
  },
  update: (type = 'BASIC_SETTING', formdata) => {
    const url = `/settings?type=${type}`;
    return axiosClient.post(url, formdata);
  },
  getMetadata: () => {
    const url = '/settings/get-meta-data';
    return axiosClient.get(url);
  },
};

export default settingAccountApi;
